import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { AuthService } from './auth.service';
import { Role, roleSatisfies } from './models';

/**
 * `canMatch` guard: only matches the route when authenticated, else redirects to
 * `/login`. Using `canMatch` (not `canActivate`) means the lazy chunk isn't even
 * loaded for an unauthenticated user (protects the cold-start budget).
 */
export const requireAuth: CanMatchFn = () => {
  const auth = inject(AuthService);
  return auth.isAuthenticated() ? true : inject(Router).parseUrl('/login');
};

/**
 * `canMatch` guard requiring the active-tenant role to satisfy one of
 * <paramref name="required"/> (styreleder satisfies styremedlem). Blocks the
 * styre lazy lib for a beboer — redirects to `/`.
 */
export function requireRole(...required: Role[]): CanMatchFn {
  return () => {
    const auth = inject(AuthService);
    const router = inject(Router);
    if (!auth.isAuthenticated()) {
      return router.parseUrl('/login');
    }

    const held = auth.activeRole();
    return required.some((role) => roleSatisfies(held, role)) ? true : router.parseUrl('/');
  };
}
